import styled from 'styled-components/macro'

export const Container = styled.div`
  width: 100%;
  background-color: #e8ebeb;
  height: fit-content;
  padding: 16px;
  position: relative;
  margin-top: 32px;
  border-radius: 8px;
  background-image: linear-gradient(rgb(216 216 216 / 0%), rgb(216, 216, 216));
`
export const DriversImg = styled.img`
  position: absolute;
  top: 22px;
  right: 12px;
  cursor: pointer;
`
export const DriversTitle = styled.div`
  padding-left: 0px;
  font-family: 'L10';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  margin: 0;
  margin-bottom: 2px;
`
export const DriversContent = styled.li`
  font-family: 'L10';
  font-style: normal;
  font-size: 13px;
  line-height: 20px;
`
